export const envs = ['prod', 'qa', 'dev', 'test'];
export const teams = ['Content', 'CMS', 'Backend', 'Client', 'Art'];
